import { Helmet } from 'react-helmet';
import TaikhoanmymobiDetail from 'src/components/taikhoanmymobi-detail/TaikhoanmymobiDetail';

import {
  Box,
  Container,
} from '@material-ui/core';

const Taikhoanmymobi = () => (
  <>
    <Helmet>
      <title>Tài khoản My Mobifone</title>
    </Helmet>
    <Box
      sx={{
        backgroundColor: 'background.default',
        minHeight: '100%',
        py: 3
      }}
    >
      <Container style={{maxWidth: "100%"}}>
        <Box sx={{ pt: 3 }}>
          <TaikhoanmymobiDetail />
        </Box>
      </Container>
    </Box>
  </>
);

export default Taikhoanmymobi;
